<template>
  <sj-dropdown
    ref="dropdown"
    placement="bottom"
    trigger="click"
    @show="handleShow"
    :closeOnClick="false"
    appendToBody
    boundariesSelector="body"
  >
    <div slot="reference" class="trigger">
      <slot />
    </div>
    <div slot="dropdown">
      <div class="color-container">
        <div>
          <div class="color-title">标准色</div>
          <div style="display: flex">
            <div class="color-content">
              <div
                :class="{ borderRadius }"
                class="color-item"
                v-for="color in colors1"
                :key="color"
                @click="onManualPick(color)"
                :style="{ backgroundColor: color }"
              ></div>
            </div>
            <!--新组件样式修改，去除两列样式-->
            <!--<div class="color-content">
              <div
                class="color-item"
                v-for="color in colors2"
                :key="color"
                @click="onManualPick(color)"
                :style="{ backgroundColor: color }"
              ></div>
            </div>-->
          </div>
        </div>
        <div style="margin-top: 5px">
          <div class="color-title">主题色</div>
          <div style="display: flex">
            <div class="color-content">
              <div
                class="color-item"
                :class="{ borderRadius }"
                v-for="color in standard"
                :key="color"
                @click="onManualPick(color)"
                :style="{ backgroundColor: color }"
              ></div>
            </div>
            <!--新组件样式修改，去除两列样式-->
            <!--<div class="color-content">
              <div
                class="color-item"
                v-for="color in standard2"
                :key="color"
                @click="onManualPick(color)"
                :style="{ backgroundColor: color }"
              ></div>
            </div>-->
          </div>
        </div>
        <ColorPicker
          :value="value"
          @input="onManualPick"
          @reset="onReset"
          v-bind="$attrs"
        >
          <div class="color-more">更多颜色...</div>
        </ColorPicker>
      </div>
    </div>
  </sj-dropdown>
</template>

<script>
/**
 * 此colorpicker具有快捷选择功能
 * 更多颜色选择部分与Element的colorpicker基本一致
 * 对reference做出修改使其支持任意元素
 */
import ColorPicker from "./colorpicker";

export default {
  name: "SjColorPicker",
  components: {
    ColorPicker
  },
  props: {
    value: String,
    borderRadius: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // colors1: [
      //   "#CF1322",
      //   "#D46B08",
      //   "#D4B106",
      //   "#389E0D",
      //   "#08979C",
      //   "#1D39C4",
      //   "#F5222D",
      //   "#FA8C16",
      //   "#FADB14",
      //   "#52C41A",
      //   "#36CFC9",
      //   "#2F54EB",
      //   "#FF4D4F",
      //   "#FFA940",
      //   "#FFEC3D",
      //   "#73D13D",
      //   "#5CDBD3",
      //   "#85A5FF",
      //   "#FF7875",
      //   "#FFD591",
      //   "#FFFB8F",
      //   "#B7EB8F",
      //   "#87E8DE",
      //   "#ADC6FF",
      //   "#FFA39E",
      //   "#FFE7BA",
      //   "#FFFFB8",
      //   "#D9F7BE",
      //   "#B5F5EC",
      //   "#D6E4FF"
      // ],
      colors1: [
        "#34457A",
        "#D46F7F",
        "#B4CD83",
        "#A08AB9",
        "#A6D5E3",
        "#F9B175",
        "#000000",
        "#535353",
        "#A7A7A7",
        "#C5C5C5",
        "#DDDDDD",
        "#FFFFFF"
      ],
      colors2: [
        "#9F3244",
        "#2A3862",
        "#7C9547",
        "#675081",
        "#3C899F",
        "#C57838",
        "#C63D55",
        "#34457A",
        "#9CBB59",
        "#8064A2",
        "#4AACC6",
        "#F79645",
        "#D46F7F",
        "#67749B",
        "#B4CD83",
        "#A08AB9",
        "#78C1D5",
        "#F9B175",
        "#E39EAA",
        "#9AA2BC",
        "#CDDDAC",
        "#C0B1D0",
        "#A6D5E3",
        "#FBCBA3",
        "#535353",
        "#000000",
        "#A7A7A7",
        "#FFFFFF",
        "#DDDDDD"
      ],

      // standard: [
      //   "#34457A",
      //   "#D46F7F",
      //   "#B4CD83",
      //   "#A08AB9",
      //   "#A6D5E3",
      //   "#F9B175"
      // ],
      standard: [
        "#2A3862",
        "#9F3244",
        "#7C9547",
        "#675081",
        "#3C899F",
        "#C57838",
        "#34457A",
        "#C63D55",
        "#9CBB59",
        "#8064A2",
        "#4AACC6",
        "#F79645",
        "#67749B",
        "#D46F7F",
        "#B4CD83",
        "#A08AB9",
        "#78C1D5",
        "#F9B175",
        "#9AA2BC",
        "#E39EAA",
        "#CDDDAC",
        "#C0B1D0",
        "#A6D5E3",
        "#FBCBA3"
      ],
      standard2: ["#0064FF", "#E5EFFF"],

      storeColor: null
    };
  },
  methods: {
    onManualPick(color) {
      this.$emit("input", color);
      this.$refs.dropdown.doClose();
    },
    onReset() {
      this.$emit("input", this.storeColor);
      this.$refs.dropdown.doClose();
    },
    handleShow() {
      this.storeColor = this.value;
    }
  }
};
</script>

<style lang="less" scoped>
.trigger {
  display: inline-block;
}
.color-container {
  text-align: left;
  padding: 10px 5px 10px 8px;

  .color-title {
    .text("caption", "dark");
    margin-bottom: 5px;
  }

  .color-content {
    width: 120px;
    display: flex;
    flex-wrap: wrap;
    margin-left: 2px;
    margin-bottom: 5px;

    .color-item {
      width: 15px;
      height: 15px;
      border-radius: 2px;
      box-sizing: border-box;
      margin: 0 5px 5px 0;

      // &:hover{
      //   border: 1px solid #354052;
      // }
    }
    .borderRadius {
      border-radius: 50%;
    }
  }
}
.color-more {
  .text("caption", "available");
  cursor: pointer;

  &:hover {
    .text("caption", "highlight");
  }
}
</style>
